module.exports = __webpack_public_path__ + "img/subaru.svg";